import { getAdminApiToken as readAdminToken } from '../../api/authToken';
import { apiRequest } from '../../api/client';

export async function getAdminApiToken() {
  return readAdminToken();
}

export async function adminRequest(path, { method = 'GET', body } = {}) {
  const token = await getAdminApiToken();
  return apiRequest(path, {
    method,
    token,
    ...(body !== undefined ? { body } : {}),
  });
}

export async function adminGet(path) {
  return adminRequest(path, { method: 'GET' });
}

export async function adminCall(path, payload = {}) {
  return adminRequest(path, { method: 'POST', body: payload || {} });
}
